<hawk-record-navigation
  class="app-page"
  [breadcrumbLinkList]="[{ description: 'Filialen', link: '/a/filiale' }]"
  [root]="'store'"
  [leafDescription]="'Neue Filiale'"
>
  <div slot="toolbar" class="flex flex-row gap-2 items-center"></div>
  <div class="page-content px-4 pb-2 overflow-auto">
    <form [formGroup]="storeForm" class="page-sheet max-w-7xl mx-auto grid grid-cols-3" (submit)="onSubmit()">
      <fieldset class="bm-fieldset p-4">
        <legend class="bm-fieldset-legend text-lg">Stammdaten</legend>
        <ng-container [ngTemplateOutlet]="tplStammdaten" />
      </fieldset>
      <fieldset class="bm-fieldset p-4">
        <legend class="bm-fieldset-legend text-lg">Ausstattung</legend>
        <ng-container [ngTemplateOutlet]="tplAusstattung" />
      </fieldset>
      <fieldset class="bm-fieldset p-4 relative">
        <legend class="bm-fieldset-legend text-lg">Adresse</legend>
        <div id="address_geocoder" class="absolute -top-8 right-4"></div>
        <ng-container [ngTemplateOutlet]="tplAdresse" />
      </fieldset>
      <div class="flex flex-row gap-2 items-center justify-end mt-6 col-span-3">
        <a [routerLink]="'/filiale/'" class="bm-btn"> Abbrechen </a>
        <button class="bm-btn bm-btn-primary" [disabled]="!storeForm.valid">Filiale erstellen</button>
      </div>
    </form>
  </div>
</hawk-record-navigation>

<ng-template #tplStammdaten>
  <label class="bm-fieldset-label">Store-Nr*</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.nr" />

  <label class="bm-fieldset-label">Name*</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.name" />

  <label class="bm-fieldset-label">Kunden</label>
  <ng-select
    [formControl]="storeForm.controls.customer_ids"
    [items]="customers"
    [multiple]="true"
    bindLabel="name"
    bindValue="id"
  />

  <label class="bm-fieldset-label">E-Mail</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.email" />

  <label class="bm-fieldset-label">Telefon 1</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.phone1" />

  <label class="bm-fieldset-label">Telefon 2</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.phone2" />

  <label class="bm-fieldset-label">Kommentar</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.comment" />
</ng-template>

<ng-template #tplAusstattung>
  <label class="bm-fieldset-label">Anzahl Kassen</label>
  <input class="bm-input w-full" type="number" min="0" [formControl]="storeForm.controls.register" />

  <label class="bm-fieldset-label">IP</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.ip" />
</ng-template>

<ng-template #tplAdresse>
  <label class="bm-fieldset-label">Firma</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.company" />

  <label class="bm-fieldset-label">Name</label>
  <div class="flex flex-row gap-2">
    <input
      class="bm-input w-full"
      type="text"
      [formControl]="storeForm.controls.address_firstname"
      placeholder="Vorname"
    />
    <input
      class="bm-input w-full"
      type="text"
      [formControl]="storeForm.controls.address_lastname"
      placeholder="Nachname"
    />
  </div>

  <label class="bm-fieldset-label">Straße</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.street" />

  <label class="bm-fieldset-label">PLZ / Ort</label>
  <div class="flex flex-row gap-2">
    <input class="flex-1 bm-input w-full" type="text" [formControl]="storeForm.controls.zip" placeholder="PLZ" />
    <input class="flex-2 bm-input w-full" type="text" [formControl]="storeForm.controls.city" />
  </div>

  <label class="bm-fieldset-label">Land</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.country" />

  <label class="bm-fieldset-label">Staat</label>
  <input class="bm-input w-full" type="text" [formControl]="storeForm.controls.state" />
</ng-template>
